export default __webpack_public_path__ + "bc01f1001bd5445ef6d1fd7d34880d8d.png";